import { DateTime } from 'luxon';

export const getDefaultGraphTimeForForecastDay = (
  date: string,
  timeZone: string,
  isToday: boolean,
): string => {
  if (isToday) {
    const now = DateTime.now().setZone(timeZone);
    if (now.isValid) {
      return now.toISO() ?? `${date}T12:00:00`;
    }
  }

  return (
    DateTime.fromISO(`${date}T08:00:00`, { zone: timeZone }).toISO() ??
    `${date}T08:00:00`
  );
};
